// src/services/socketService.js
import { io } from 'socket.io-client';

let socket = null;
let channel = null;
let isLeader = false;
let isInitialized = false;

function getChannel() {
  if (!channel) {
    channel = new BroadcastChannel('notifications_channel');
  }
  return channel;
}

export function initSocket(userId) {
  // Prevent multiple initializations
  if (isInitialized) {
    // console.log('[Socket] Already initialized');
    return;
  }

  isInitialized = true;
  // console.log('[Socket] Initializing socket for userId:', userId);

  const bc = getChannel();

  // Ask if there’s already a leader
  bc.postMessage({ type: 'REQUEST_LEADER' });

  let leaderCheckTimeout = setTimeout(() => {
    // No leader responded — this tab becomes leader
    // console.log('[Socket] No leader found, becoming leader');
    becomeLeader(userId);
  }, 500);

  bc.onmessage = (event) => {
    const { type, data } = event.data || {};

    if (type === 'LEADER_EXISTS') {
      // console.log('[Socket] Leader already exists');
      clearTimeout(leaderCheckTimeout);
    }

    if (type === 'NOTIFICATION') {
      // console.log('[Socket] Received notification via BroadcastChannel:', data);
      window.dispatchEvent(new CustomEvent('socket-notification', { detail: data }));
    }

    if (type === 'REQUEST_LEADER' && isLeader) {
      // Another tab is asking if there's a leader — tell it yes
      bc.postMessage({ type: 'LEADER_EXISTS' });
    }
  };
}

function becomeLeader(userId) {
  isLeader = true; // Now this tab is the leader
  const bc = getChannel();

  bc.postMessage({ type: 'LEADER_EXISTS' });

  // console.log('[Socket] Connecting to:', process.env.REACT_APP_API_URL, 'with userId:', userId);
  socket = io(process.env.REACT_APP_API_URL, { query: { userId } });

  socket.on('connect', () => {
    // console.log('[Socket] Connected successfully, socket ID:', socket.id);
  });

  socket.on('disconnect', (reason) => {
    // console.log('[Socket] Disconnected:', reason);
  });

  socket.on('connect_error', (error) => {
    console.error('[Socket] Connection error:', error);
  });

  socket.on('notification', (notification) => {
    // console.log('[Socket] Received notification from server:', notification);
    bc.postMessage({ type: 'NOTIFICATION', data: notification });
    window.dispatchEvent(new CustomEvent('socket-notification', { detail: notification }));
  });

  window.addEventListener('beforeunload', () => {
    if (socket) socket.disconnect();
  });
}
